<p-accordion>
  <app-expansion-panel title="General Appearance" value="0">
    <app-general-appearance-form #generalAppearanceForm [formGroup]="generalAppearanceFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="HEENT" value="1">
    <app-heent-form #heentForm [formGroup]="heentFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Cardiovascular" value="2">
    <app-cardiovascular-form #cardiovascularForm [formGroup]="cardiovascularFormGroup" />
  </app-expansion-panel>

  <app-expansion-panel title="Respiratory" value="3">
    <app-respiratory-form #respiratoryForm [formGroup]="respiratoryFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Neurological" value="4">
    <app-neurological-form #neurologicalForm [formGroup]="neurologicalFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Musculoskeletal" value="5">
    <app-musculoskeletal-form #musculoskeletalForm [formGroup]="musculoskeletalFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Abdominal" value="6">
    <app-gastrointestinal-form #gastrointestinalForm [formGroup]="gastrointestinalFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Genitourinary" value="7">
    <app-genitourinary-form #genitourinaryForm [formGroup]="genitourinaryFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Psychosocial" value="8">
    <app-psychosocial-form #psychosocialForm [formGroup]="psychosocialFormGroup" />
  </app-expansion-panel>

  <app-expansion-panel title="Integumentary" value="9">
    <app-integumentary-form #integumentaryForm [formGroup]="integumentaryFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Pain Assessment" value="10">
    <app-pain-assessment-form #painAssessmentForm [formGroup]="painFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Intake and Output" value="11">
    <app-intake-output-form #intakeOutputForm [formGroup]="intakeOutputFormGroup" [patient]="patient" />
  </app-expansion-panel>

  <app-expansion-panel title="Provider Notified" value="12">
    <app-provider-notified-form #providerNotifiedForm [formGroup]="providerNotifiedFormGroup" />
  </app-expansion-panel>

  <!-- @if (isAdmin) {
  <div class="assessment-date">
    <h3>Time of Assessment</h3>
    <emr-input type="time" [control]="dateFormControl" placeholder="Assessment Time" />
  </div>
  } -->

  <button pButton class="add-assessment-btn" color="accent" (click)="onSubmit()">
    Add Assessment
  </button>
</p-accordion>